import { ubtPage } from '@/shared/utils/ubt';
import { ExtraType } from './types';

export default class UbtHelper {
  public constructor(pageId: string) {
    this.pageId = pageId;
  }

  private pageId: string;

  private inTime = new Date().getTime();

  enterPage(extra?: ExtraType | undefined): void {
    this.inTime = new Date().getTime();
    ubtPage(this.pageId, '', this.inTime, undefined, extra);
  }

  leavePage(extra?: ExtraType | undefined): void {
    ubtPage(this.pageId, '', this.inTime, new Date().getTime(), extra);
  }
}
